export enum PaySessionStatus {
	CREATED = 'created',
	DISCOUNTING = 'discounting',
	PARTIALLY_PAID = 'partially_paid',
	FINISHED = 'finished',
}
